import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivateChild,
} from '@angular/router';
import { Observable } from 'rxjs';

import { LcAClService } from './lc-acl.service';

/**
 * 目前用不到，startup.service.js 启动的时候已经判断当前的url是否是合法的
 */
@Injectable({
  providedIn: 'root',
})
export class LcAclGuard implements CanActivate, CanActivateChild {
  constructor(protected srv: LcAClService, private router: Router) {}

  process(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.srv.canAuthUrl(state.url)) {
      return true;
    }
    let guard_url = route.data.guard_url || '/auth/403';
    this.router.navigateByUrl(guard_url);
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.process(route, state);
  }

  // all children route
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.process(childRoute, state);
  }
}
